import { Skeleton } from '@/components/ui/skeleton';

import { CONNECTORS } from './helpers/connectors';

export const ConnectorsSkeleton = () => (
  <section className='flex flex-col gap-3' aria-busy='true'>
    <div className='flex items-center gap-2'>
      <Skeleton className='h-6 w-24' />
      <Skeleton className='h-5 w-6' />
    </div>
    <div className='divide-y overflow-hidden rounded-lg border bg-card'>
      {CONNECTORS.map(({ id }) => (
        <div key={id} className='flex items-center gap-4 px-5 py-4'>
          <Skeleton className='size-10 shrink-0' />
          <div className='flex min-w-0 flex-1 flex-col gap-2'>
            <Skeleton className='h-4 w-40' />
            <Skeleton className='h-3.5 w-64 max-w-full' />
          </div>
          <div className='flex shrink-0 gap-2'>
            <Skeleton className='h-8 w-28' />
            <Skeleton className='h-8 w-28' />
          </div>
        </div>
      ))}
    </div>
  </section>
);
